import { BONE_LOSS_KEYS } from "duck";
import { Fragments } from "requests";
import { FormValues } from "./types";

type BoneLossKey = keyof FormValues;

export const getDefaultValues = (
  generalAssessment: Fragments.StoredGeneralAssessment
) => {
  if (!generalAssessment) {
    return;
  }

  return Object.keys(generalAssessment).reduce((acc, key) => {
    if (BONE_LOSS_KEYS.includes(key)) {
      acc[key as BoneLossKey] =
        generalAssessment[key as BoneLossKey].join(", ") || "";
    }
    return acc;
  }, {} as Record<BoneLossKey, string>);
};
